import { Edit3, Send, Play, Plus, Pause, Info } from "lucide-react";
import { Button } from "@shared/ui/button";
import { Card, CardContent } from "@shared/ui/card";
import { PageHeader } from "@shared/components/PageHeader";
import { usePauseMeterSchedule } from "@features/mx/readCycleManagement/hooks";
import { useNavigate, useParams } from "react-router-dom";
import { useRemoteUtilityId } from "@shared/selectors/globalSelectors";
import { useState } from "react";
import RunCycleMessage from "./runCycleMessage";
import CreateRoute from "../../details/createRoute";

const ScheduleQuickActionCard = ({
  scheduleDetails,
}: {
  scheduleDetails: any[];
}) => {
  const navigate = useNavigate();
  const { schedule_id } = useParams();
  const utilityId = useRemoteUtilityId();
  const [openRunCycleMessage, setOpenRunCycleMessage] = useState(false);
  const [openCreateRoute, setOpenCreateRoute] = useState(false);
  const pauseMeterSchedule = usePauseMeterSchedule(schedule_id);
  const handlePauseSchedule = () => {
    pauseMeterSchedule.mutateAsync({
      schedule_id: Number(schedule_id),
      remote_utility_id: Number(utilityId),
      is_pause: scheduleDetails?.[0].status === "Paused" ? false : true,
    });
  };
  return (
    <div>
      <Card>
        {/* Header */}
        <PageHeader title="Quick Actions" />

        {/* Actions */}
        <CardContent className="space-y-3 flex flex-col mt-3">
          {/* Edit Schedule */}
          <Button
            variant="outline"
            className="w-full justify-center p-2"
            onClick={() =>
              navigate(`/mx/schedule/edit/${scheduleDetails?.[0].id}`)
            }
          >
            <Edit3 size={18} />
            Edit Schedule
          </Button>

          {/* Dispatch for Reading */}
          <Button
            variant="outline"
            className="w-full justify-center p-2"
            tooltip="Use this to trigger an immediate reading run without waiting for the scheduled occurrence. Helpful in testing, reruns, or urgent operations."
            tooltipPosition="left"
            onClick={() =>
              navigate(
                `/mx/meterread/photo-meter/${scheduleDetails?.[0].runId}?tab=routes`
              )
            }
            disabled={!scheduleDetails?.[0].runId}
          >
            <Send size={18} />
            Dispatch for Reading
          </Button>

          {/* Run Now */}
          <Button
            variant="outline"
            className="w-full justify-center p-2"
            tooltip="Triggers a run aligned with the schedule configuration."
            tooltipPosition="left"
            onClick={() => {
              setOpenRunCycleMessage(true);
            }}
          >
            <Play size={18} fill="currentColor" />
            Run Now
          </Button>

          {/* Add / Remove Routes */}
          <Button
            variant="outline"
            className="w-full justify-center p-2"
            onClick={() => {
              setOpenCreateRoute(true);
            }}
          >
            <Plus size={18} />
            Add Routes
          </Button>

          {/* Pause Schedule */}
          <Button
            variant="outline"
            className="w-full justify-center p-2"
            onClick={() => {
              handlePauseSchedule();
            }}
            disabled={scheduleDetails?.[0].status === "Overdue"}
          >
            {scheduleDetails?.[0].status === "Paused" ? (
              <Play size={18} fill="currentColor" />
            ) : (
              <Pause size={18} />
            )}
            {scheduleDetails?.[0].status === "Paused"
              ? "Resume Schedule"
              : "Pause Schedule"}
          </Button>
        </CardContent>
      </Card>
      <RunCycleMessage
        open={openRunCycleMessage}
        setOpen={setOpenRunCycleMessage}
      />
      <CreateRoute
        entityName="Schedule"
        openCreateRoute={openCreateRoute}
        setOpenCreateRoute={setOpenCreateRoute}
        meterCycleId={scheduleDetails?.[0].meterCycle}
      />
    </div>
  );
};

export default ScheduleQuickActionCard;
